// Stopka (07): akordeony list na telefonie i popover „Warunki i polityki”.
import { Theme, mq } from '@theme/core';

// Stan startowy (telefon: zwinięte) ustawia skrypt w linii sekcji, przed malowaniem stopki.
class FooterMenus extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;
    const wide = mq(750);
    // ≥750 listy zawsze widoczne; powrót na telefon = stan startowy.
    const reset = () => {
      for (const details of this.querySelectorAll('details')) details.open = wide.matches;
    };
    wide.addEventListener('change', reset, { signal });
    if (!Theme.designMode) return;
    // Edytor wstawia sekcję od nowa; zaznaczona kolumna rozwija się na telefonie.
    reset();
    this.addEventListener('shopify:block:select', (event) => {
      const details = event.target.querySelector?.('details');
      if (details) details.open = true;
    }, { signal });
  }

  disconnectedCallback() {
    this.abort.abort();
  }
}

// Klik, klawiaturę, Esc i klik poza obsługuje natywnie popovertarget + popover="auto".
// Tu: najechanie myszą (200 ms) i pozycja bez CSS anchor positioning (07 FR-07-13/14).
class FooterPolicies extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('[popovertarget]');
    const popover = this.querySelector('[popover]');
    if (!trigger || !popover) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    const anchored = CSS.supports('anchor-name', '--a');
    const later = (fn) => {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, 200);
    };
    // Stan z DOM (mógł się otworzyć przed definicją); bez API natywnego metody i matches() łata polyfill.
    const isOpen = () => !!popover.showPopover && popover.matches(':popover-open');
    const show = () => isOpen() || popover.showPopover?.();
    const hide = () => isOpen() && popover.hidePopover?.();
    const mouse = (fn) => (event) => event.pointerType === 'mouse' && fn();
    trigger.addEventListener('pointerenter', mouse(() => later(show)), { signal });
    trigger.addEventListener('pointerleave', mouse(() => later(hide)), { signal });
    popover.addEventListener('pointerenter', mouse(() => clearTimeout(this.timer)), { signal });
    popover.addEventListener('pointerleave', mouse(() => later(hide)), { signal });
    popover.addEventListener('beforetoggle', (event) => {
      if (event.newState !== 'open' || anchored) return;
      const { top, left, width } = trigger.getBoundingClientRect();
      popover.style.setProperty('--anchor-top', top);
      popover.style.setProperty('--anchor-left', left);
      popover.style.setProperty('--anchor-width', width);
    }, { signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
    clearTimeout(this.timer);
  }
}

if (!customElements.get('footer-menus')) customElements.define('footer-menus', FooterMenus);
if (!customElements.get('footer-policies')) customElements.define('footer-policies', FooterPolicies);
